import PmHome from '@components/organisms/PmHome.vue'

import PmAbout from '@components/organisms/PmAbout.vue'
import PmWhatWeDo from '@components/molecules/PmWhatWeDo.vue'
import PmOurHistory from '@components/molecules/PmOurHistory.vue'
import PmManagementTeam from '@components/molecules/PmManagementTeam.vue'
import PmOurPortfolio from '@components/molecules/PmOurPortfolio.vue'
import PmOurVisionFor5g from '@components/molecules/PmOurVisionFor5g.vue'

import PmProducts from '@components/organisms/PmProducts.vue'
import PmSmallCells from '@components/molecules/PmSmallCells.vue'
import PmDas from '@components/molecules/PmDas.vue'
import PmOpticalFiber from '@components/molecules/PmOpticalFiber.vue'
import PmTowersAndRooftops from '@components/molecules/PmTowersAndRooftops.vue'

import PmPortfolio from '@components/organisms/PmPortfolio.vue'
import PmPropertyDevelopers from '@components/molecules/PmPropertyDevelopers.vue'

import PmServices from '@components/organisms/PmServices.vue'
import PmWeLease from '@components/molecules/PmWeLease.vue'
import PmWeBuild from '@components/molecules/PmWeBuild.vue'
import PmWeManage from '@components/molecules/PmWeManage.vue'
import PmWeBuy from '@components/molecules/PmWeBuy.vue'

import PmMunicipalities from '@components/organisms/PmMunicipalities.vue'
import PmSmartCities from '@components/molecules/PmSmartCities.vue'

import PmCareers from '@components/organisms/PmCareers.vue'
import PmCareersIndex from '@components/molecules/PmCareersIndex.vue'
import PmJobDetail from '@components/molecules/PmJobDetail.vue'

import PmPress from '@components/organisms/PmPress.vue'

import PmContact from '@components/organisms/PmContact.vue'

import PmInvestors from '@components/organisms/PmInvestors.vue'

import PmPublications from '@components/organisms/PmPublications.vue'

import PmRightsReserved from '@components/organisms/PmRightsReserved.vue'

import PmNewsEnvironmental from '@components/organisms/PmNewsEnvironmental.vue'


const routes = [
  { path: '/', component: PmHome, name: 'Home', props: true, meta: { isname: 'home', lang: 'EN' }, props: { lang: 'EN' } },
  { path: '/en/', component: PmHome, name: 'Home', props: true, meta: { isname: 'home', lang: 'EN' }, props: { lang: 'EN' } },
  {
    path: '/en/about',
    component: PmAbout,
    name: 'About',
    meta: { isname: 'about', lang: 'EN' },
    props: { lang: 'EN' },
    children: [
      { path: '/', name: 'What We Do', component: PmWhatWeDo, transitionName: 'slide', meta: { isname: 'about', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'what-we-do', name: 'What We Do', component: PmWhatWeDo, transitionName: 'slide', meta: { isname: 'about', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'our-history', name: 'Our History', component: PmOurHistory, transitionName: 'slide', meta: { isname: 'about', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'management-team', name: 'Management Team', component: PmManagementTeam, transitionName: 'slide', meta: { isname: 'about', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'our-portfolio', name: 'Our Portfolio', component: PmOurPortfolio, transitionName: 'slide', meta: { isname: 'about', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'our-vision-for-5g', name: 'Our Vision for 5G', component: PmOurVisionFor5g, transitionName: 'slide', meta: { isname: 'about', lang: 'EN' }, props: { lang: 'EN' } }
    ]
  },
  {
    path: '/en/products',
    name: 'Products',
    component: PmProducts,
    meta: { isname: 'products', lang: 'EN' },
    props: { lang: 'EN' },
    children: [
      { path: '/', name: 'Small Cells', component: PmSmallCells, meta: { isname: 'products', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'small-cells', name: 'Small Cells', component: PmSmallCells, meta: { isname: 'products', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'das', name: 'DAS', component: PmDas, meta: { isname: 'products', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'optical-fiber', name: 'Optical Fiber', component: PmOpticalFiber, meta: { isname: 'products', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'towers-and-rooftops', name: 'Towers and Rooftops', component: PmTowersAndRooftops, meta: { isname: 'products', lang: 'EN' }, props: { lang: 'EN' } }
    ]
  },
  {
    path: '/en/portfolio',
    name: 'Property Developers',
    component: PmPortfolio,
    meta: { isname: 'portfolio', lang: 'EN' },
    props: { lang: 'EN' },
    children: [
      { path: '/', name: 'Property Developers', component: PmPropertyDevelopers, props: { lang: 'EN' }, meta: { isname: 'portfolio', lang: 'EN' } },
      { path: 'property-developers', name: 'Property Developers', component: PmPropertyDevelopers, props: { lang: 'EN' }, meta: { isname: 'portfolio', lang: 'EN' } },
      { path: 'land-owners', name: 'Land Owners', component: PmPropertyDevelopers, props: { lang: 'EN' }, meta: { isname: 'portfolio', lang: 'EN' } },
      { path: 'comercial-and-real-estate-owners', name: 'Commercial and Real Estate Owners', component: PmPropertyDevelopers, props: { lang: 'EN' }, meta: { isname: 'portfolio', lang: 'EN' } },
      { path: 'large-venues', name: 'Large Venues', component: PmPropertyDevelopers, props: { lang: 'EN' }, meta: { isname: 'portfolio', lang: 'EN' } },
      { path: 'infrastructure-owners', name: 'Infrastructure Owners', component: PmPropertyDevelopers, props: { lang: 'EN' }, meta: { isname: 'portfolio', lang: 'EN' } },
      { path: 'public-services-companies', name: 'Public Service Companies', component: PmPropertyDevelopers, props: { lang: 'EN' }, meta: { isname: 'portfolio', lang: 'EN' } },
      { path: 'city-and-street-furniture-owners', name: 'City and Street Furniture Owners', component: PmPropertyDevelopers, props: { lang: 'EN' }, meta: { isname: 'portfolio', lang: 'EN' } }
    ]
  },
  {
    path: '/en/services',
    name: 'Services',
    component: PmServices,
    meta: { isname: 'services', lang: 'EN' },
    props: { lang: 'EN' },
    children: [
      { path: '/', name: 'We Lease', component: PmWeLease, props: { lang: 'EN' }, meta: { isname: 'services', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'we-lease', name: 'We Lease', component: PmWeLease, props: { lang: 'EN' }, meta: { isname: 'services', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'we-build', name: 'We Build', component: PmWeBuild, props: { lang: 'EN' }, meta: { isname: 'services', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'we-manage', name: 'We Manage', component: PmWeManage, props: { lang: 'EN' }, meta: { isname: 'services', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'we-buy', name: 'We Buy', component: PmWeBuy, props: { lang: 'EN' }, meta: { isname: 'services', lang: 'EN' }, props: { lang: 'EN' } }
    ]
  },
  {
    path: '/en/municipalities',
    name: 'Municipalities',
    component: PmMunicipalities,
    meta: { isname: 'municipalities', lang: 'EN' },
    props: { lang: 'EN' },
    children: [
      { path: '/', name: 'Smart Cities', component: PmSmartCities, props: { lang: 'EN' }, meta: { isname: 'municipalities', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'smart-cities', name: 'Smart Cities', component: PmSmartCities, props: { lang: 'EN' }, meta: { isname: 'municipalities', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'internet-of-things', name: 'Internet of Things', component: PmSmartCities, props: { lang: 'EN' }, meta: { isname: 'municipalities', lang: 'EN' }, props: { lang: 'EN' } },
      { path: 'public-safety', name: 'Public Safety', component: PmSmartCities, props: { lang: 'EN' }, meta: { isname: 'municipalities', lang: 'EN' }, props: { lang: 'EN' } }
    ]
  },
  { path: '/en/press', name: 'Press', component: PmPress, meta: { isname: 'press', lang: 'EN' }, props: { lang: 'EN' } },
  { path: '/en/investors', name: 'Investors', component: PmInvestors, meta: { isname: 'investors', lang: 'EN' }, props: { lang: 'EN' } },
  { path: '/en/contact', name: 'Contact', component: PmContact, meta: { isname: 'contact', lang: 'EN' }, props: { lang: 'EN' } },
  { path: '/en/publications', name: 'Publications', component: PmPublications, meta: { isname: 'publication', lang: 'EN' }, props: { lang: 'EN' } },
  { path: '/en/terms-of-use', name: 'Terms of Use', component: PmRightsReserved, meta: { isname: 'Terms of Use', lang: 'EN' }, props: { lang: 'EN' } },
  { path: '/en/news-environmental', name: 'News Enviromental', component: PmNewsEnvironmental, meta: { isname: 'News Enviromental', lang: 'EN' }, props: { lang: 'EN' } },

  {
    path: '/en/careers',
    name: 'Careers',
    component: PmCareers,
    meta: { isname: 'careers', lang: 'EN' },
    props: { lang: 'EN' },
    children: [
      { path: '/', name: 'Careers', component: PmCareersIndex, props: { lang: 'EN' }, meta: { isname: 'careers', lang: 'EN' }, props: { lang: 'EN' } },
      { path: ':job', name: 'job', component: PmJobDetail, props: { lang: 'EN' }, meta: { isname: 'careers', lang: 'EN' }, props: { lang: 'EN' } }
    ]
  },

  { path: '/es/', component: PmHome, name: 'Inicio', props: true, meta: { isname: 'home' } },
  {
    path: '/es/acerca-de-atp',
    component: PmAbout,
    name: 'Acerca de ATP',
    meta: { isname: 'about' },
    children: [
      { path: '/', name: 'Que Hacemos', component: PmWhatWeDo, transitionName: 'slide' },
      { path: 'que-hacemos', name: 'Que Hacemos', component: PmWhatWeDo, transitionName: 'slide' },
      { path: 'nuestra-historia', name: 'Nuestra Historia', component: PmOurHistory, transitionName: 'slide' },
      { path: 'equipo-directivo', name: 'Equipo Directivo', component: PmManagementTeam, transitionName: 'slide' },
      { path: 'nuestro-portafolio', name: 'Nuestro Portafolio', component: PmOurPortfolio, transitionName: 'slide' },
      { path: 'nuestra-vision-5g', name: 'Nuestra Vision 5G', component: PmOurVisionFor5g, transitionName: 'slide' }
    ]
  },
  {
    path: '/es/productos',
    name: 'Products',
    component: PmProducts,
    meta: { isname: 'products' },
    children: [
      { path: '/', name: 'Small Cells', component: PmSmallCells },
      { path: 'small-cells', name: 'Small Cells', component: PmSmallCells },
      { path: 'das', name: 'DAS', component: PmDas },
      { path: 'fibra-optica', name: 'Fibra Optica', component: PmOpticalFiber },
      { path: 'torres-y-azoteas', name: 'Torres y Azoteas', component: PmTowersAndRooftops }
    ]
  },
  {
    path: '/es/portafolio',
    name: 'Desarroladores de bienes raices',
    component: PmPortfolio,
    meta: { isname: 'portfolio' },
    children: [
      { path: '/', name: 'Desarroladores de bienes raices', component: PmPropertyDevelopers },
      { path: 'desarrolladores-de-bienes-raices', name: 'Desarroladores de bienes raices', component: PmPropertyDevelopers },
      { path: 'propietarios-de-predios', name: 'Propietarios de Predios', component: PmPropertyDevelopers },
      { path: 'propietarios-de-inmuebles-comerciales', name: 'Propietarios de Inmuebles Comerciales', component: PmPropertyDevelopers },
      { path: 'propietarios-de-inmuebles-insignia', name: 'Propietarios de Inmuebles Insignia', component: PmPropertyDevelopers },
      { path: 'dueños-de-infraestructura', name: 'Dueños de Infraestructura', component: PmPropertyDevelopers },
      { path: 'organizaciones-de-servicios-publicos', name: 'Organizaciones de Servicios Públicos', component: PmPropertyDevelopers },
      { path: 'propietarios-de-mobiliario-urbano', name: 'Propietarios de Mobiliario Urbano', component: PmPropertyDevelopers }
    ]
  },
  {
    path: '/es/servicios',
    name: 'Services',
    component: PmServices,
    meta: { isname: 'services' },
    children: [
      { path: '/', name: 'Alquilamos', component: PmWeLease },
      { path: 'alquilamos', name: 'Alquilamos', component: PmWeLease },
      { path: 'construimos', name: 'Construimos', component: PmWeBuild },
      { path: 'administramos', name: 'Administramos', component: PmWeManage },
      { path: 'compramos', name: 'Compramos', component: PmWeBuy }
    ]
  },
  {
    path: '/es/municipios',
    name: 'Municipalities',
    component: PmMunicipalities,
    meta: { isname: 'municipalities' },
    children: [
      { path: '/', name: 'Ciudades Inteligentes', component: PmSmartCities },
      { path: 'ciudades-inteligentes', name: 'Ciudades Inteligentes', component: PmSmartCities },
      { path: 'internet-of-things', name: 'Internet of Things', component: PmSmartCities },
      { path: 'seguridad-publica', name: 'Seguridad Publica', component: PmSmartCities }
    ]
  },
  { path: '/es/noticias', name: 'Noticias', component: PmPress, meta: { isname: 'press' } },
  { path: '/es/inversionistas', name: 'Inversionistas', component: PmInvestors, meta: { isname: 'inversionistas' } },
  { path: '/es/contacto', name: 'Contacto', component: PmContact, meta: { isname: 'contact' } },
  { path: '/es/publicaciones', name: 'Publicaciones', component: PmPublications, meta: { isname: 'publicaciones' } },
  { path: '/es/terminos-de-uso', name: 'Terminos de Uso', component: PmRightsReserved, meta: { isname: 'Terms of Use' } },
  { path: '/es/noticias-ambientales', name: 'Noticias ambientales', component: PmNewsEnvironmental, meta: { isname: 'News Enviromental' } },

  {
    path: '/es/oportunidades',
    name: 'Oportunidades',
    component: PmCareers,
    meta: { isname: 'careers' },
    children: [
      { path: '/', name: 'Oportunidades', component: PmCareersIndex },
      { path: ':job', name: 'Trabajo', component: PmJobDetail }
    ]
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js